import { sortDocuments } from '@arc/unified-payments-frontend/shared-payment';
import { createSelector } from '@ngrx/store';
import { BtpaySessionStore } from '../reducers/session.reducer';

export const selectSessionDocuments = createSelector(
  BtpaySessionStore,
  (state) => state?.selectedDocuments,
);

export const selectPayableRestrictions = createSelector(
  BtpaySessionStore,
  (state) => state?.payableRestrictionsHistory,
);

export const selectSortedSessionDocuments = createSelector(
  selectSessionDocuments,
  (state) => sortDocuments(state?.slice()),
);

export const selectSelectedDocuments = createSelector(
  selectSessionDocuments,
  (state) => sortDocuments(state?.filter((d) => d.isSelected)),
);

export const selectInvoiceCount = createSelector(
  selectSelectedDocuments,
  (state) => state?.filter((d) => !d.isCreditMemo).length ?? 0,
);

export const selectPayableDocuments = createSelector(
  selectSelectedDocuments,
  (state) => sortDocuments(state?.filter((d) => d.isPayable)),
);

export const selectNonPayableInvoiceCount = createSelector(
  selectSelectedDocuments,
  (state) => state?.filter((d) => !d.isPayable && !d.isCreditMemo).length ?? 0,
);

export const selectNumberOfDocumentsNotPayableWithPaymentMethod =
  createSelector(
    selectSelectedDocuments,
    selectPayableRestrictions,
    (selectedDocuments, payableRestrictionsHistory) =>
      selectedDocuments?.filter((d) => {
        const restrictions = payableRestrictionsHistory?.find(
          (r) => r.documentUrn === d.urn,
        );
        return (
          restrictions?.isRejected &&
          // only include in count if at least one payment method is available
          (restrictions?.isPayableWithBank || restrictions?.isPayableWithCard)
        );
      }).length ?? 0,
  );

export const selectAreAllDocumentsNotPayable = createSelector(
  selectInvoiceCount,
  selectNonPayableInvoiceCount,
  (invoiceCount, notPayableInvoiceCount) =>
    invoiceCount == notPayableInvoiceCount,
);

/* istanbul ignore next */
export const selectAreThereDocumentsPendingDeselection = createSelector(
  selectSessionDocuments,
  (documents) =>
    documents.some((document) => document.duplicatePaymentSoftBlockPending),
);
